import React from 'react';
import { useLocation } from 'react-router-dom';
import camelcaseKeys from 'camelcase-keys';
import queryString from 'query-string';

import BuyPackageContainer from '@src/containers/BuyPackage';
import NewPaymentContainer from '@src/containers/NewPayment';
import { useSelector } from 'react-redux';
import { SMS_IDENTITY_PROVIDER } from '@src/constants';
import PaymentSMS from '@src/containers/NewPayment/PaymentSMS';

const Payment = () => {
  const location = useLocation();

  const { identityProvider } = useSelector((state) => state.auth.user);
  const isSMSUser = Object.values(SMS_IDENTITY_PROVIDER).includes(
    identityProvider,
  );

  const { orderId, package: packageCode } = camelcaseKeys(
    queryString.parse(location.search) || {},
  );

  const renderPaymentScreen = () => {
    if (orderId || packageCode) {
      if (isSMSUser) {
        return <PaymentSMS />;
      }

      return <NewPaymentContainer />;
    }

    return <BuyPackageContainer />;
  };

  return renderPaymentScreen();
};

export default Payment;
